/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import Vue from 'vue';
import { Message, MessageBox } from 'element-ui';
import _ from 'lodash';
import {
    GET_ORDER_LIST_REQUEST,
    GET_ORDER_LIST_SUCCESS,
    GET_ORDER_LIST_FAILURE,
    UPDATE_ORDER_LIST,
    UPDATE_ORDER_LIST_PARAMS,
    RESET_ORDER_LIST,
    RESOLVE_ORDER_LIST_PARAMS,
    UPDATE_EXPORT_ORDER_URL,
    UPDATE_WAIT_DATA
} from '../mutationTypes';

const state = {
    loading: false,
    businessType: 0, // 业务类型（0:全部, 1：收银开单，7：师傅接车，2：PC购买爱车卡订单， 9：PC储值卡充值）—-(v3.5新增)
    orderState: 0, // 订单状态（0：全部，1：待结算，2：已结算，3：挂账，4：已作废）—-(v3.5新增)
    workState: 0, // 施工状态（0：全部，1：待施工，2：施工中，3：已完工）—-(v3.5新增)
    page: 1,
    pagesize: 20,
    name: '',
    mobile: '',
    payType: 3, // 支付类型,1当面付(默认),2现金,3微信,4支付宝,5刷卡
    companyName: '', // 企业名称
    carNo: '',
    orderNo: '',
    operate_count:'',
    startEndDate: [], // 组件返回形式为数组, 请求时分开提交
    listData: [],
    waitData: {},
    pageCount: 1,
    reqParams: {},
    exportOrderUrl: '' // 导出链接
};

const mutations = {
    [GET_ORDER_LIST_REQUEST](state) {
        state.loading = true;
    },
    [GET_ORDER_LIST_SUCCESS](state, res) {
        state.loading = false;
        state.pageCount = res.page_count;
        state.listData = res.listData;
        state.waitData = res.waitData;
    },
    [UPDATE_WAIT_DATA](state, res) {
        state.waitData = res;
    },
    [UPDATE_EXPORT_ORDER_URL](state, res) {
        state.exportOrderUrl = res;
    },
    [UPDATE_ORDER_LIST](state, res) {
        state.listData = res;
    },
    [GET_ORDER_LIST_FAILURE](state) {
        state.loading = false;

        state.pageCount = 1;
        state.listData = [];
    },
    // 更新请求参数
    [UPDATE_ORDER_LIST_PARAMS](state, params) {
        const {
            name, mobile, page, carNo,
            orderNo, startEndDate, businessType,
            orderState, workState, operateCount,
            payType, companyName
        } = params;

        if (name || name === '') state.name = name;
        if (mobile || mobile === '') state.mobile = mobile;
        if (carNo || carNo === '') state.carNo = carNo;
        if (orderNo || orderNo === '') state.orderNo = orderNo;
        if (operateCount || operateCount === '') state.operate_count = operateCount;
        if (businessType || businessType === 0) state.businessType = businessType;
        if (orderState || orderState === 0) state.orderState = orderState;
        if (workState || workState === 0) state.workState = workState;
        if (payType) state.payType = payType;
        if (payType) state.reqParams.payType = payType;
        if (companyName || companyName === '') state.companyName = companyName;
        if (startEndDate) {
            state.startEndDate = startEndDate;
        }

        if (page) {
            state.page = page;
            state.reqParams.page = page; // 分页要进行请求
        }
    },
    [RESET_ORDER_LIST](state) {
        _.extend(state, _.cloneDeep({
            loading: false,
            businessType: 0,
            orderState: 0,
            workState: 0,
            page: 1,
            pagesize: 20,
            name: '',
            mobile: '',
            payType: 3,
            companyName: '',
            carNo: '',
            orderNo: '',
            operate_count: '',
            startEndDate: [],
            listData: [],
            pageCount: 1,
            reqParams: {}
        }));
    },
    [RESOLVE_ORDER_LIST_PARAMS](state, reqParams) {
        state.reqParams = reqParams;
    },
};

export const actions = {
    async getOrderList({ commit }) {
        commit(GET_ORDER_LIST_REQUEST);
        const res = await Vue.$ajax.get('orderList', state.reqParams);
        let exportOrderUrl = '';
        // eslint-disable-next-line guard-for-in
        // eslint-disable-next-line no-restricted-syntax
        // eslint-disable-next-line no-unused-vars
        for (const key in state.reqParams) {
            const val = state.reqParams[key] === null ? '' : state.reqParams[key];
            exportOrderUrl += `&${key}=${val}`;
        }
        commit(UPDATE_EXPORT_ORDER_URL, exportOrderUrl);
        if (!res.errorType) {
            commit(GET_ORDER_LIST_SUCCESS, res);
        } else {
            commit(GET_ORDER_LIST_FAILURE);
        }
    },
    async exportOrderList() {
        const res = await Vue.$ajax.get('exportOrders', state.reqParams);
        if (!res.errorType) {
            Message({
                message: '导出成功',
                tyep: 'success'
            });
        } else {
            MessageBox.alert(res.errmsg || '未知错误', '提交失败！', {
                confirmButtonText: '知道了'
            });
        }
    },
    /**
     * 根据搜索条件批量完成挂账订单
     */
    async finishOrderCondition({ commit }) {
        // console.log(objVal);
        console.log(state.reqParams);
        const res = await Vue.$ajax.post('finishOrderCondition', state.reqParams);
        console.log('params=>', state.reqParams);
        if (!res.errorType) {
            Message({
                message: '批量收银完成',
                tyep: 'success'
            });
            const newListData = JSON.parse(JSON.stringify(state.listData));
            /* 批量操作后，将列表的挂账订单改为已结算 */
            newListData.forEach((item, index) => {
                if (item.orderState === 3) {
                    newListData[index].orderState = 2;
                }
            });
            commit(UPDATE_ORDER_LIST, newListData);
            /* 更新可批量完成为0 */
            commit(UPDATE_WAIT_DATA, {total: 0, count: 0});
        } else {
            MessageBox.alert(res.errmsg || '未知错误', '操作失败！', {
                confirmButtonText: '我知道了'
            });
        }
    },
    /**
     * 根据订单id批量完成挂账订单
     */
    async finishOrderIds({ commit }, objVal) {
        const res = await Vue.$ajax.post('finishOrderIds', objVal);
        if (!res.errorType) {
            Message({
                message: '批量收银完成',
                tyep: 'success'
            });
            /* 深拷贝 否则会报 warning */
            const newListData = JSON.parse(JSON.stringify(state.listData));
            const orderIds = objVal.orderIds.split(',');
            /* 批量操作后，改变勾选的订单状态为已结算 */
            newListData.forEach((item, index) => {
                if (orderIds.indexOf(item.orderId) >= 0) {
                    newListData[index].orderState = 2;
                }
            });
            commit(UPDATE_ORDER_LIST, newListData);
        } else {
            MessageBox.alert(res.errmsg || '选中挂账订单中，无法全部处理为已结算状态，请重新选择。', '操作失败！', {
                confirmButtonText: '我知道了'
            });
        }
    },
    resolveOrderListParams({ commit }) {
        let params = _.pick(state, ['name', 'mobile', 'orderState', 'workState', 'businessType',
            'page', 'pagesize', 'carNo', 'orderNo', 'operate_count', 'companyName']);

        params = Object.assign({}, params, {
            startDate: state.startEndDate.length ? state.startEndDate[0] : null,
            endDate: state.startEndDate.length ? state.startEndDate[1] : null
        });
        commit(RESOLVE_ORDER_LIST_PARAMS, params);
    },
    resetOrderList({ commit }) {
        commit(RESET_ORDER_LIST);
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/orderList.js